import { SafeSuspense } from '@calendly/safe-suspense'
import { Loader } from '@calendly/ui/components/loader'
import { lazy } from 'react'

const loadChunk = async () => {
  const loaded = await import(/* webpackChunkName: 'userGroups' */'./content')
  return { default: loaded.Content }
}

const Content = lazy(loadChunk)

export const List = () => (
  <SafeSuspense fallback={<Loader />}>
    <Content />
  </SafeSuspense>
)
